import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function Footer() {
  const {
    t,
    lang
  } = useLanguage();
  const medicalDisclaimer = lang === 'es' ? 'AVISO MÉDICO: Los resultados varían entre cada paciente. El Lipolaser es un procedimiento estético no quirúrgico y no es un tratamiento para la obesidad ni un sustituto de dieta y ejercicio. Toda candidatura es evaluada individualmente por el equipo médico. Las imágenes utilizadas representan casos reales con consentimiento expreso.' : 'MEDICAL DISCLAIMER: Individual results vary. Lipolaser is a non-surgical aesthetic procedure and is not a treatment for obesity nor a substitute for diet and exercise. All candidacy is evaluated individually by the medical team. Images depict actual patients shared with express consent.';
  return <footer className="bg-brand-dark text-brand-cream py-24 relative overflow-hidden" data-id="element-168">
      <div className="absolute inset-0 bg-grain opacity-50 pointer-events-none" data-id="element-169"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-170">
        {/* Top: brand + tagline */}
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-171">
          <a href="/" className="inline-flex flex-col items-center gap-2 mb-8" data-id="element-172">
            <span className="text-3xl font-serif font-light text-brand-cream" data-id="element-173">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.3em] uppercase text-brand-gold" data-id="element-174">
              Beverly Hills
            </span>
          </a>

          <p className="text-brand-cream/60 font-light italic font-serif mb-6" data-id="element-175">
            {t('footer.tagline')}
          </p>

          <div className="w-10 h-px bg-brand-gold/50 mx-auto" data-id="element-176"></div>
        </div>

        {/* Middle: navigation + legal links */}
        <div className="max-w-3xl mx-auto mb-16" data-id="element-177">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-8" data-id="element-178">
            <a href="/#beneficios" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-179">
              {t('nav.benefits')}
            </a>
            <a href="/#proceso" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-180">
              {t('nav.process')}
            </a>
            <a href="/#doctor" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-181">
              {t('nav.doctor')}
            </a>
            <a href="/#testimonios" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-182">
              {t('nav.testimonials')}
            </a>
            <a href="/#faq" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-183">
              {t('nav.faq')}
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3" data-id="element-184">
            <Link to="/privacy" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 hover:text-brand-cream/80 transition-colors" data-id="element-185">
              {t('footer.links.privacy')}
            </Link>
            <span className="text-brand-gold/30 text-[10px]" data-id="element-186">·</span>
            <Link to="/terms" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 hover:text-brand-cream/80 transition-colors" data-id="element-187">
              {t('footer.links.terms')}
            </Link>
            <span className="text-brand-gold/30 text-[10px]" data-id="element-188">·</span>
            <Link to="/disclaimer" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 hover:text-brand-cream/80 transition-colors" data-id="element-189">
              {lang === 'es' ? 'Aviso Médico' : 'Medical Disclaimer'}
            </Link>
          </div>
        </div>

        {/* Medical disclaimer block — visible & required */}
        <div className="max-w-4xl mx-auto pt-12 border-t border-brand-cream/10" data-id="element-190">
          <p className="text-[10px] text-brand-cream/40 font-light leading-relaxed text-center mb-8 tracking-wide" data-id="element-191">
            {medicalDisclaimer}
          </p>

          <p className="text-[10px] text-brand-cream/30 font-light leading-relaxed text-center max-w-2xl mx-auto mb-8 italic" data-id="element-192">
            {lang === 'es' ? 'Lipo Laser · Dermaclinic Beverly Hills opera bajo las regulaciones del Estado de California y cumple con HIPAA en el manejo de información médica protegida.' : 'Lipo Laser · Dermaclinic Beverly Hills operates under California State regulations and complies with HIPAA in the handling of protected health information.'}
          </p>

          <p className="text-brand-cream/30 text-[10px] font-medium tracking-widest uppercase text-center" data-id="element-193">
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}